"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "*filter"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.728923 1.71909C0.838161 1.48365 1.07412 1.33301 1.33367 1.33301H14.667C14.9266 1.33301 15.1625 1.48365 15.2717 1.71909C15.381 1.95453 15.3436 2.23197 15.176 2.43016L10.0003 8.55044V13.9997C10.0003 14.2307 9.8807 14.4453 9.68415 14.5668C9.48761 14.6882 9.24218 14.6993 9.03553 14.596L6.36886 13.2626C6.143 13.1497 6.00033 12.9189 6.00033 12.6663V8.55044L0.824621 2.43016C0.657023 2.23197 0.619684 1.95453 0.728923 1.71909ZM2.77054 2.66634L7.17605 7.87586C7.27782 7.99621 7.33367 8.14873 7.33367 8.30634V12.2543L8.667 12.921V8.30634C8.667 8.14873 8.72284 7.99621 8.82462 7.87586L13.2301 2.66634H2.77054Z",
    fill: fill
  })));
};

exports["default"] = _default;